module.exports = __webpack_public_path__ + "64fad40a726451abad7ccbc87418cc67.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/ca2.png
// module id = 798
// module chunks = 3